var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3075 0.544142L7.11098 14.245L3.34374 10.22C2.64977 9.56569 1.55925 9.52604 0.76615 10.0812C-0.00712629 10.6562 -0.22523 11.6674 0.250632 12.4803L4.71184 19.7372C5.14805 20.4114 5.90149 20.8278 6.75408 20.8278C7.56701 20.8278 8.34029 20.4114 8.77649 19.7372C9.49029 18.8053 23.1118 2.56656 23.1118 2.56656C24.8963 0.742417 22.7351 -0.863616 21.3075 0.524314V0.544142Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWhiteIcon);
export default __webpack_public_path__ + "static/media/check-white-icon.c80b7756ed60d61000fb8fff5e15aaec.svg";
export { ForwardRef as ReactComponent };